export interface ICompanyLicense {
  id: string;
  company_id: string;
  license_num: number;
  applicable_date: string;
}

export class CompanyLicenseDTO implements ICompanyLicense {
  id: string;
  company_id: string;
  license_num: number;
  applicable_date: string;
}

export default class CompanyLicense extends CompanyLicenseDTO {
  constructor(dto?: CompanyLicenseDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      company_id: null,
      license_num: 0,
      applicable_date: null,
    });
  }
}
